"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoDDCountryResponse = exports.WhoDDCcodeEntity = exports.WhoDDC3SearchResponse = exports.WhoDDC3SearchColumnTypes = exports.WhoDDB3SearchResponse = exports.WhoDDB3SearchColumnTypes = exports.WhoDDSearchQuery = exports.WhoDDSearchOptionKeys = exports.WhoDDVersion = exports.KoDDSearchResponse = exports.KoDDVersion = exports.MeddraSearchResponse = exports.MeddraVersion = exports.AtcCodeSearchResponse = exports.AtcCodeVersion = void 0;
// ATC CODE
// TODO: 업데이트 시 maven-rest에도 반영 필요
var AtcCodeVersion;
(function (AtcCodeVersion) {
    AtcCodeVersion["v2021"] = "2021";
    AtcCodeVersion["v2022"] = "2022";
})(AtcCodeVersion = exports.AtcCodeVersion || (exports.AtcCodeVersion = {}));
class AtcCodeSearchResponse {
}
exports.AtcCodeSearchResponse = AtcCodeSearchResponse;
// MEDDRA
// TODO: 업데이트 시 maven-rest에도 반영 필요
var MeddraVersion;
(function (MeddraVersion) {
    MeddraVersion["v23_1"] = "23.1";
    MeddraVersion["v24_0"] = "24.0";
    MeddraVersion["v24_1"] = "24.1";
    MeddraVersion["v25_0"] = "25.0";
    MeddraVersion["v25_1"] = "25.1";
})(MeddraVersion = exports.MeddraVersion || (exports.MeddraVersion = {}));
class MeddraSearchResponse {
}
exports.MeddraSearchResponse = MeddraSearchResponse;
// KoDD
// TODO: 업데이트 시 maven-rest에도 반영 필요
var KoDDVersion;
(function (KoDDVersion) {
    KoDDVersion["v2020_12"] = "2020.12";
    KoDDVersion["v2021_03"] = "2021.03";
    KoDDVersion["v2021_06"] = "2021.06";
    KoDDVersion["v2021_09"] = "2021.09";
    KoDDVersion["v2021_12"] = "2021.12";
    KoDDVersion["v2022_03"] = "2022.03";
    KoDDVersion["v2022_06"] = "2022.06";
    KoDDVersion["v2022_09"] = "2022.09";
})(KoDDVersion = exports.KoDDVersion || (exports.KoDDVersion = {}));
class KoDDSearchResponse {
}
exports.KoDDSearchResponse = KoDDSearchResponse;
// TODO: 업데이트 시 maven-rest에도 반영 필요
var WhoDDVersion;
(function (WhoDDVersion) {
    WhoDDVersion["v2022_09_b3"] = "WHODRUG GLOBAL B3 September 1, 2022";
    WhoDDVersion["v2022_09_c3"] = "WHODRUG GLOBAL C3 September 1, 2022";
})(WhoDDVersion = exports.WhoDDVersion || (exports.WhoDDVersion = {}));
var WhoDDSearchOptionKeys;
(function (WhoDDSearchOptionKeys) {
    WhoDDSearchOptionKeys["isExactMatch"] = "isExactMatch";
    WhoDDSearchOptionKeys["isGenericAndPreferred"] = "isGenericAndPreferred";
    WhoDDSearchOptionKeys["isOnlyGeneric"] = "isOnlyGeneric";
    WhoDDSearchOptionKeys["isUmbrellaRecords"] = "isUmbrellaRecords";
    WhoDDSearchOptionKeys["isOldForm"] = "isOldForm";
})(WhoDDSearchOptionKeys = exports.WhoDDSearchOptionKeys || (exports.WhoDDSearchOptionKeys = {}));
class WhoDDSearchQuery {
}
exports.WhoDDSearchQuery = WhoDDSearchQuery;
var WhoDDB3SearchColumnTypes;
(function (WhoDDB3SearchColumnTypes) {
    WhoDDB3SearchColumnTypes["DrugCode"] = "DRUG_CODE";
    WhoDDB3SearchColumnTypes["DrugName"] = "DRUG_NAME";
    WhoDDB3SearchColumnTypes["Ingredients"] = "INGREDIENTS";
})(WhoDDB3SearchColumnTypes = exports.WhoDDB3SearchColumnTypes || (exports.WhoDDB3SearchColumnTypes = {}));
class WhoDDB3SearchResponse {
}
exports.WhoDDB3SearchResponse = WhoDDB3SearchResponse;
var WhoDDC3SearchColumnTypes;
(function (WhoDDC3SearchColumnTypes) {
    WhoDDC3SearchColumnTypes["MedicinalprodId"] = "MEDICINALPROD_ID";
    WhoDDC3SearchColumnTypes["DrugCode"] = "DRUG_CODE";
    WhoDDC3SearchColumnTypes["DrugName"] = "DRUG_NAME";
    WhoDDC3SearchColumnTypes["Ingredients"] = "INGREDIENTS";
    WhoDDC3SearchColumnTypes["Country"] = "COUNTRY";
    WhoDDC3SearchColumnTypes["Organization"] = "ORGANIZATION";
    WhoDDC3SearchColumnTypes["PharmForm"] = "PHARM_FORM";
    WhoDDC3SearchColumnTypes["PharmStrength"] = "PHARM_STRENGTH";
})(WhoDDC3SearchColumnTypes = exports.WhoDDC3SearchColumnTypes || (exports.WhoDDC3SearchColumnTypes = {}));
class WhoDDC3SearchResponse {
}
exports.WhoDDC3SearchResponse = WhoDDC3SearchResponse;
class WhoDDCcodeEntity {
}
exports.WhoDDCcodeEntity = WhoDDCcodeEntity;
class WhoDDCountryResponse {
}
exports.WhoDDCountryResponse = WhoDDCountryResponse;
//# sourceMappingURL=dokdo.js.map